<template>
  <attach-email v-if="valueName == 'attach_email'" />
  <attachment v-else-if="valueName == 'attachment'" />
  <cloud v-else-if="valueName == 'cloud'" />
  <cloud-circle v-else-if="valueName == 'cloud_circle'" />
  <cloud-done v-else-if="valueName == 'cloud_done'" />
  <cloud-download v-else-if="valueName == 'cloud_download'" />
  <cloud-off v-else-if="valueName == 'cloud_off'" />
  <cloud-queue v-else-if="valueName == 'cloud_queue'" />
  <cloud-upload v-else-if="valueName == 'cloud_upload'" />
  <create-new-folder v-else-if="valueName == 'create_new_folder'" />
  <download v-else-if="valueName == 'download'" />
  <download-done v-else-if="valueName == 'download_done'" />
  <folder v-else-if="valueName == 'folder'" />
  <folder-open v-else-if="valueName == 'folder_open'" />
  <folder-shared v-else-if="valueName == 'folder_shared'" />
  <request-quote v-else-if="valueName == 'request_quote'" />
  <rule-folder v-else-if="valueName == 'rule_folder'" />
  <snippet-folder v-else-if="valueName == 'snippet_folder'" />
  <text-snippet v-else-if="valueName == 'text_snippet'" />
  <topic v-else-if="valueName == 'topic'" />
  <upload v-else-if="valueName == 'upload'" />
</template>

<script>
import AttachEmail from "@/components/Icons/File/AttachEmail";
import Attachment from "@/components/Icons/File/Attachment";
import Cloud from "@/components/Icons/File/Cloud";
import CloudCircle from "@/components/Icons/File/CloudCircle";
import CloudDone from "@/components/Icons/File/CloudDone";
import CloudDownload from "@/components/Icons/File/CloudDownload";
import CloudOff from "@/components/Icons/File/CloudOff";
import CloudQueue from "@/components/Icons/File/CloudQueue";
import CloudUpload from "@/components/Icons/File/CloudUpload";
import CreateNewFolder from "@/components/Icons/File/CreateNewFolder";
import Download from "@/components/Icons/File/Download";
import DownloadDone from "@/components/Icons/File/DownloadDone";
import Folder from "@/components/Icons/File/Folder";
import FolderOpen from "@/components/Icons/File/FolderOpen";
import FolderShared from "@/components/Icons/File/FolderShared";
import RequestQuote from "@/components/Icons/File/RequestQuote";
import RuleFolder from "@/components/Icons/File/RuleFolder";
import SnippetFolder from "@/components/Icons/File/SnippetFolder";
import TextSnippet from "@/components/Icons/File/TextSnippet";
import Topic from "@/components/Icons/File/Topic";
import Upload from "@/components/Icons/File/Upload";

export default {
  components: {
    AttachEmail,
    Attachment,
    Cloud,
    CloudCircle,
    CloudDone,
    CloudDownload,
    CloudOff,
    CloudQueue,
    CloudUpload,
    CreateNewFolder,
    Download,
    DownloadDone,
    Folder,
    FolderOpen,
    FolderShared,
    RequestQuote,
    RuleFolder,
    SnippetFolder,
    TextSnippet,
    Topic,
    Upload,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
